<template>
  <div>
    <div class="pt-2" v-html="formSubDesc"/>
    <div class="row mt-4">
      <div class="col-md-12 col-12 form-field">

        <p>
        <div class="title pt-2">Requested by</div>
        <div class="mb-4">
          <input class="form-control w-100 mt-1" v-model="userFullName" disabled="true"/>
        </div>

        <p>
          <input type="checkbox" @click="toggleRequestingForOthers"
                 :checked="exceptionSubmissionRequestData.isRequestingForOthers">
          <span class="title ml-2" @click="toggleRequestingForOthers">I am submitting this request on behalf of someone else</span>
        </p>

        <div v-if="exceptionSubmissionRequestData.isRequestingForOthers">
          <div class="title">
            <div class="required-field">Requested for</div>
            <div class="text-muted">This person will be responsible for answering detailed supplier questions.</div>
          </div>

          <div class="mb-4 mt-2" v-if="usersLoaded.isRequestedForOthersLoaded">

            <help-hub-user-search
                :env="appEnv"
                @onUserSelected="onRequestedForUserSelected"
                @onUserRemoved="clearRequestedForUser"
                autocomplete="nope"
                :selected-users="exceptionSubmissionRequestData.requestedForUser"
                ref="userSearch"
            />
            <span
                class="text-danger input-error-text"
                v-if="userSearchIsInvalid"
            >This field is required</span>
          </div>
        </div>

        <p>
          <input @click="toggleRequestToAddWatchers" type="checkbox"
                 :checked="exceptionSubmissionRequestData.isRequestingForWatchers">
          <span @click="toggleRequestToAddWatchers" class="title ml-2">I wish to allow watchers on this request</span>
        </p>


        <div v-if="exceptionSubmissionRequestData.isRequestingForWatchers">
          <div class="title">
            <div class="required-field">Request to add watcher</div>
            <div class="text-muted">The watchers will be able to track your request on your behalf.</div>
          </div>
          <div class="mb-4 mt-2">
            <help-hub-user-search
                :env="appEnv"
                :is-multi-select="true"
                :selected-users="exceptionSubmissionRequestData.stringifiedWatchers"
                @onUserSelected="onWatchersSelected"
                @onUserRemoved="onUserRemoved">
            </help-hub-user-search>
            <span
                class="text-danger input-error-text"
                v-if="isWatchersEmpty"
            >This field is required</span>
          </div>
        </div>

        <div class="pb-2">
          <div class="title mt-3 required-field">
            <span>1. </span>
            <span>Request type</span>
          </div>
          <div class="my-2">
            <div class="item select-style">
              <model-list-select
                  :list="requestForOptions"
                  :optionValue="'value'"
                  :optionText="'text'"
                  @input="updateFilteredRequestFor($event)"
                  name="exceptionSubmissionRequestData.exceptionRequestFor"
                  v-validate="'required'"
                  data-vv-validate-on="input"
                  v-model="exceptionSubmissionRequestData.exceptionRequestFor"
                  class="w-25"/>
            </div>
            <show-errors
                :for-item="'exceptionSubmissionRequestData.exceptionRequestFor'"
                :formErrors="errors"
                :field-name="exceptionSubmissionRequestData.exceptionRequestFor" />
          </div>
        </div>


        <div v-if="filteredSubmissionRequestFor === requestForMap.OTHER">
          <div class="title pt-2 required-field">
            <span>1. a </span>
            <span>{{ requestForCheckBoxText.OTHER_TEXT }}</span>
          </div>
          <div class="mb-4">
            <input
                class="form-control w-100 mt-1"
                name="exceptionSubmissionRequestData.additionalDescription"
                v-model="exceptionSubmissionRequestData.additionalDescription"
                id="exceptionSubmissionRequestData.additionalDescription"
                v-validate="'required'"
                autocomplete="off"
                data-vv-validate-on="input"
            >
          </div>
          <show-errors
              :for-item="'exceptionSubmissionRequestData.additionalDescription'"
              :formErrors="errors"
              :field-name="exceptionSubmissionRequestData.additionalDescription" />
        </div>

        <span v-if="filteredSubmissionRequestFor === requestForMap.SPONSORSHIP">
          Go to <a target="_blank" :href="requestForMap.SPONSORSHIP_URL">“Marketing Toolkit – Sponsorships”</a> for step-by-step instructions, including Sponsorship Agreement
          <br/>
           <label class="row no-gutters required-field mt-2 mb-2 d-inline-block">
                <span class="mr-2">1. a</span>
                <input
                    key="index"
                    type="checkbox"
                    name="exceptionSubmissionRequestData.stepsCompletedForSponsorship"
                    v-validate="'required'"
                    v-model="exceptionSubmissionRequestData.stepsCompletedForSponsorship"
                    data-vv-validate-on="input"
                ><span class="ml-2">{{ requestForCheckBoxText.SPONSORSHIP_TEXT }}</span></label>
                <show-errors
                  :for-item="'exceptionSubmissionRequestData.stepsCompletedForSponsorship'"
                  :formErrors="errors"
                  :field-name="exceptionSubmissionRequestData.stepsCompletedForSponsorship" />
        </span>

        <span v-if="filteredSubmissionRequestFor === requestForMap.CORPORATE_DONATION">
          Go to <a target="_blank" :href="requestForMap.DONATION_URL">“Corporate donations”</a> for step-by-step instructions
          <br/>
          <label class="row required-field no-gutters mt-2 mb-2 d-inline-block">
            <span class="mr-2">1. a</span>
                <input
                    key="index"
                    type="checkbox"
                    v-validate="'required'"
                    name="exceptionSubmissionRequestData.stepsCompletedForCorporateDonation"
                    v-model="exceptionSubmissionRequestData.stepsCompletedForCorporateDonation"
                    data-vv-validate-on="input"
                ><span class="ml-2">{{ requestForCheckBoxText.CORPORATE_DONATION_TEXT }}</span></label>
          <show-errors
              :for-item="'exceptionSubmissionRequestData.stepsCompletedForCorporateDonation'"
              :formErrors="errors"
              :field-name="exceptionSubmissionRequestData.stepsCompletedForCorporateDonation" />
        </span>

        <span v-if="filteredSubmissionRequestFor === requestForMap.SPEAKER">
          Go to <a target="_blank" :href="requestForMap.SPEAKER_URL">“Marketing Toolkit – Speakers"</a> for step-by-step instructions, including approved contract templates.
          <br/>
          <label class="row no-gutters required-field mt-2 mb-2 d-inline-block">
          <span class="mr-2">1. a</span>
          <input
              key="index"
              type="checkbox"
              v-validate="'required'"
              name="exceptionSubmissionRequestData.approvalAgreementAvailableForSpeaker"
              v-model="exceptionSubmissionRequestData.approvalAgreementAvailableForSpeaker"
              data-vv-validate-on="input"
          ><span
              class="ml-2">{{ requestForCheckBoxText.SPEAKER_TEXT }}</span></label>
          <show-errors
              :for-item="'exceptionSubmissionRequestData.approvalAgreementAvailableForSpeaker'"
              :formErrors="errors"
              :field-name="exceptionSubmissionRequestData.approvalAgreementAvailableForSpeaker" />
        </span>

        <span v-if="displayGenericCheckBox(filteredSubmissionRequestFor)">
          Go to <a target="_blank" :href="requestForMap.GENERIC_CHECKBOX_URL">“Exceptions to Supplier Central process"</a> for step-by-step instructions.
          <br/>
          <label class="row no-gutters required-field mt-2 mb-2 d-inline-block">
          <span class="mr-2">1. a</span>
          <input
              type="checkbox"
              v-validate="'required'"
              name="exceptionSubmissionRequestData.necessaryStepsAndSupportingDocumentationCompleted"
              v-model="exceptionSubmissionRequestData.necessaryStepsAndSupportingDocumentationCompleted"
              data-vv-validate-on="input"
          ><span
              class="ml-2">{{ requestForCheckBoxText.GENERIC_CHECKBOX_TEXT }}</span></label>
          <show-errors
              :for-item="'exceptionSubmissionRequestData.necessaryStepsAndSupportingDocumentationCompleted'"
              :formErrors="errors"
              :field-name="exceptionSubmissionRequestData.necessaryStepsAndSupportingDocumentationCompleted" />
        </span>


        <div class="title pt-2 required-field">
          <span>2. </span>
          <span>Brief description</span>
        </div>
        <div class="mb-4">
          <textarea
              class="form-control w-100 mt-1 text-area-resize-none"
              v-validate="'required'"
              data-vv-validate-on="input"
              name="exceptionSubmissionRequestData.briefDescription"
              v-model="exceptionSubmissionRequestData.briefDescription"
          />
          <show-errors
              :for-item="'exceptionSubmissionRequestData.briefDescription'"
              :formErrors="errors"
              :field-name="exceptionSubmissionRequestData.briefDescription" />
        </div>

        <div class="mb-3">
          <div class="title required-field pt-2">
            <span>3. </span>
            <header-with-tooltip
                :tooltip-text="autodeskBuyingServices"
                :isHTML="true"
                :show-icon="true">
              <span class="mr-1">What Autodesk company is buying these services / this product?</span>
            </header-with-tooltip>
          </div>
          <div class="item select-style custom-input">

            <div class="d-inline" :key="index" v-for="(checkbox,index) in oneIntakeCheckBoxCountries">
              <label class="row no-gutters mt-2 mb-2">
                <input
                    class="oneIntakeCheckBoxCountries"
                    :key="index"
                    type="checkbox"
                    name="exceptionSubmissionRequestData.companyBuyingServiceCheckBox"
                    v-model="exceptionSubmissionRequestData.companyBuyingServiceCheckBox"
                    :value="checkbox"
                    data-vv-validate-on="input"
                > {{ checkbox.text }}</label>
            </div>

            <input type="checkbox" id="other" @click="toggleOthersSelected"
                   :checked="exceptionSubmissionRequestData.isCompanyBuyingServicesOthersSelected"
                   class="oneIntakeCheckBoxCountries">
            <label for="other">Other</label>

            <multi-select
                v-if="exceptionSubmissionRequestData.isCompanyBuyingServicesOthersSelected"
                :options="countryListOptions"
                :optionText="countryListOptions.text"
                :optionValue="countryListOptions.value"
                :selected-options="exceptionSubmissionRequestData.companyBuyingServices"
                data-vv-validate-on="input"
                name="exceptionSubmissionRequestData.companyBuyingServices"
                @select="onSelect"
                v-model="exceptionSubmissionRequestData.companyBuyingServices"
            />

            <span class="text-danger d-block input-error-text"
                  v-if="isCompanyBuyingServicesEmpty"
            >This field is required</span>
          </div>
        </div>

        <div class="mb-2">
          <div class="title my-4">
            <span>4. </span>
            <span>Was this supplier suggested or recommended by a government official
              , or will this supplier engagement involve any of the following:
              (a) lobbying or of consulting on government affairs;
              (b) interacting with government officials on Autodesk’s behalf;
              or (c) services involving a government official?</span>
          </div>
          <div class="d-inline">
            <label class="label-font">
              <input
                  type="radio"
                  name="exceptionSubmissionRequestData.recommendedByGovernment"
                  v-model="exceptionSubmissionRequestData.recommendedByGovernment"
                  :value="true"
                  v-validate="'required'"
              />
              Yes</label
            >

            <label class="label-font label-font-padding">
              <input
                  type="radio"
                  name="exceptionSubmissionRequestData.recommendedByGovernment"
                  v-model="exceptionSubmissionRequestData.recommendedByGovernment"
                  :value="false"
                  v-validate="'required'"
              />
              No</label
            >
          </div>
          <show-errors
              :for-item="'exceptionSubmissionRequestData.recommendedByGovernment'"
              :formErrors="errors"
              :field-name="exceptionSubmissionRequestData.recommendedByGovernment" />
        </div>

        <div class="mb-2">
          <div class="title my-4">
            <span>5. </span>
            <header-with-tooltip
                :tooltip-text="CONSTANTS.INTERACTING_WITH_AUTODESK_CUSTOMERS"
                :isHTML="true"
                :show-icon="true">
              <span class="mr-1">Will this supplier engagement involve them
                interacting with Autodesk customers on our behalf?</span>
            </header-with-tooltip>
          </div>
          <div class="d-inline">
            <label class="label-font">
              <input
                  type="radio"
                  name="exceptionSubmissionRequestData.onBehalfOfAutodeskCustomer"
                  v-model="exceptionSubmissionRequestData.onBehalfOfAutodeskCustomer"
                  :value="true"
                  v-validate="'required'"
              />
              Yes</label
            >

            <label class="label-font label-font-padding">
              <input
                  type="radio"
                  name="exceptionSubmissionRequestData.onBehalfOfAutodeskCustomer"
                  v-model="exceptionSubmissionRequestData.onBehalfOfAutodeskCustomer"
                  :value="false"
                  v-validate="'required'"
              />
              No</label
            >
          </div>
          <show-errors
              :for-item="'exceptionSubmissionRequestData.onBehalfOfAutodeskCustomer'"
              :formErrors="errors"
              :field-name="exceptionSubmissionRequestData.onBehalfOfAutodeskCustomer" />
        </div>

        <div class="mb-2">
          <div class="title my-4">
            <span>6. </span>
            <span>Do you or, to your knowledge, does anyone else at Autodesk have a relationship with the supplier
              or an employee of the supplier that must be disclosed and vetted under our Conflicts of Interest Policy?</span>
          </div>

          <div class="d-inline">
            <label class="label-font">
              <input
                  type="radio"
                  name="exceptionSubmissionRequestData.anyRelationshipWithAutodesk"
                  v-model="exceptionSubmissionRequestData.anyRelationshipWithAutodesk"
                  :value="true"
                  v-validate="'required'"
              />
              Yes</label
            >

            <label class="label-font label-font-padding">
              <input
                  type="radio"
                  name="exceptionSubmissionRequestData.anyRelationshipWithAutodesk"
                  v-model="exceptionSubmissionRequestData.anyRelationshipWithAutodesk"
                  :value="false"
                  v-validate="'required'"
              />
              No</label
            >
          </div>
          <show-errors
              :for-item="'exceptionSubmissionRequestData.anyRelationshipWithAutodesk'"
              :formErrors="errors"
              :field-name="exceptionSubmissionRequestData.anyRelationshipWithAutodesk" />
        </div>


        <div class="pt-2">

          <service-now-attachments
              :max-file-size-in-m-b="CONSTANTS.ATTACHMENTS_MAX_SIZE_IN_MB.ONE_INTAKE_FORM"
              @onAttachmentAdded="onAttachmentAdded($event)"
              :existing-files="exceptionSubmissionRequestData.attachments"
              :valid-file-types="validFileTypes"
          />
        </div>

        <div class="float-md-right mt-4 pr-0">
          <button class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3" @click="navigateToHome()">Cancel
          </button>
          <button class="btn-container btn flat-btn primary-blue-btn ml-2 my-3" @click="validateAndSetCurrentTab()">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import HeaderWithTooltip from "../HeaderWithTooltip";
import supplierRequestMixin from "@/mixins/supplierRequestMixin";
import CONSTANTS from "@/store/constants";
import {ModelListSelect, MultiSelect} from "vue-search-select";
import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";
import ServiceNowAttachments from "@/components/ServiceNowAttachments";
import api from "@/api";
import exceptionRequestMixin from "@/mixins/exceptionRequestMixin";
import ShowErrors from "@/components/Payments/ShowErrors";

export default {
  name: "GeneralInformationForExceptionRequest",
  components: {ModelListSelect, MultiSelect, HeaderWithTooltip, ServiceNowAttachments, ShowErrors},
  mixins: [supplierRequestMixin, exceptionRequestMixin],
  data() {
    return {
      appEnv: CONSTANTS.ENV,
      userSearchIsInvalid: false,
      isWatchersEmpty: false,
      isCompanyBuyingServicesEmpty: false,
      autodeskBuyingServices: EXCEPTION_SUBMISSION_CONSTANTS.AUTODESK_BUYING_SERVICES,
      requestForOptions: EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_OPTIONS,
      requestForMap: EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP,
      filteredSubmissionRequestFor: '',
      usersLoaded: {
        isRequestedForOthersLoaded: true,
        isWatchersLoaded: true
      },
      validFileTypes: CONSTANTS.FILE_TYPES.extensionAsAll.validFileTypes,
      formSubDesc: `This form is used for <a target="_blank" href="${CONSTANTS.PTP_ARTICLE_URL}">approved exceptions</a> to the Supplier Central review process.<br />
                    The purpose of the form is to collect basic information needed to complete a legal compliance review and set up the supplier for payment.<br />
                    After you submit the form, you will receive instructions to complete your purchase in Ariba.`,
      requestForCheckBoxText: EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT
    }
  },
  watch: {
    "exceptionSubmissionRequestData.exceptionRequestFor"() {
      this.resetConfirmationValues()
    },
    "exceptionSubmissionRequestData.isCompanyBuyingServicesOthersSelected"(val) {
      if (!val) {
        this.exceptionSubmissionRequestData.companyBuyingServices = []
        this.isCompanyBuyingServicesEmpty = false
      }
    },
    "exceptionSubmissionRequestData.isRequestingForOthers"(val) {
      if (!val) {
        this.clearRequestedForUser()
      }
    },
    adminDataList(val) {
      if (val) {
        this.initializeGeneralInformation();
      }
    },
    "currentUser.userName"() {
      this.updateCompanyBuyingServices(this.currentUser)
    }
  },
  created: function () {
    this.initializeGeneralInformation()
  },
  computed: {
    ...mapGetters([
      "exceptionSubmissionRequestData",
      "userData",
      "supplierServiceCategoryOptions",
      "currentUser",
    ]),
    userFullName() {
      return this.userData(this.currentUser.userName).fullName
    }
  },
  methods: {
    updateFilteredRequestFor() {
      this.filteredSubmissionRequestFor = this.getTextValue(this.requestForOptions, this.exceptionSubmissionRequestData.exceptionRequestFor)
    },
    toggleRequestingForOthers() {
      this.exceptionSubmissionRequestData.isRequestingForOthers = !this.exceptionSubmissionRequestData.isRequestingForOthers
    },
    toggleRequestToAddWatchers() {
      this.exceptionSubmissionRequestData.isRequestingForWatchers = !this.exceptionSubmissionRequestData.isRequestingForWatchers
    },
    toggleOthersSelected() {
      this.exceptionSubmissionRequestData.isCompanyBuyingServicesOthersSelected = !this.exceptionSubmissionRequestData.isCompanyBuyingServicesOthersSelected
    },
    resetConfirmationValues() {
      this.exceptionSubmissionRequestData.stepsCompletedForSponsorship = false
      this.exceptionSubmissionRequestData.stepsCompletedForCorporateDonation = false
      this.exceptionSubmissionRequestData.approvalAgreementAvailableForSpeaker = false
      this.exceptionSubmissionRequestData.additionalDescription = ''
    },
    initializeGeneralInformation() {
      this.$nextTick(() => {
        this.updateCompanyBuyingServices(this.currentUser)
        this.updateRequestedFor()
        this.updateWatchers()
        this.updateFilteredRequestFor()
        this.updateRedirectSelection()
      });
    },
    async updateRedirectSelection(){
      if(CONSTANTS.ONE_INTAKE_FORM_REDIRECT_SELECTION.length != 0){
        this.$set(this.$store.state.exceptionSubmissionRequestData, 'exceptionRequestFor',this.getValueFromList(this.requestForOptions, CONSTANTS.ONE_INTAKE_FORM_REDIRECT_SELECTION));
        this.updateFilteredRequestFor();
        CONSTANTS.ONE_INTAKE_FORM_REDIRECT_SELECTION = "";
      }
    },
    async updateRequestedFor() {
      let requestedFor = this.exceptionSubmissionRequestData.requestedFor
      if (!requestedFor || requestedFor.length === 0) return
      this.exceptionSubmissionRequestData.isRequestingForOthers = true
      this.usersLoaded.isRequestedForOthersLoaded = false
      this.exceptionSubmissionRequestData.requestedForUser = JSON.stringify([{
        userName: this.exceptionSubmissionRequestData.requestedFor,
        fullName: await this.getUserFullName(this.exceptionSubmissionRequestData.requestedFor)
      }])
      this.usersLoaded.isRequestedForOthersLoaded = true
    },
    async getUserFullName(userId) {
      let userFullName = ''
      try {
        const userResp = await api.getUserInfo(userId)
        userFullName = userResp.data.fullName
      } catch {
        userFullName = userId
      }
      return userFullName
    },
    async updateWatchers() {
      let watchList = this.exceptionSubmissionRequestData.watchers
      if (!watchList || watchList.length === 0) return
      this.exceptionSubmissionRequestData.isRequestingForWatchers = true
      this.usersLoaded.isWatchersLoaded = false
      let watchers = []

      for (let i = 0; i < watchList.length; i++) {
        let userFullName = await this.getUserFullName(watchList[i])
        watchers.push({userName: watchList[i], fullName: userFullName})
      }
      this.usersLoaded.isWatchersLoaded = true
      this.exceptionSubmissionRequestData.stringifiedWatchers = JSON.stringify(watchers)
    },
    onSelect(companyBuyingServices) {
      this.exceptionSubmissionRequestData.companyBuyingServices = companyBuyingServices;
      this.isCompanyBuyingServicesEmpty = false
    },
    onWatchersSelected(response) {
      let existingWatchers = this.exceptionSubmissionRequestData.watchers;
      existingWatchers.push(response.detail[0].userName);
      this.exceptionSubmissionRequestData.watchers = existingWatchers
      this.isWatchersEmpty = false;
    },
    onUserRemoved(response) {
      if (response.detail.length) {
        const watchersList = this.exceptionSubmissionRequestData.watchers.filter(watcher => watcher !== response.detail[0]);
        this.exceptionSubmissionRequestData.watchers = watchersList
      }
    },
    onRequestedForUserSelected(user) {
      this.exceptionSubmissionRequestData.requestedFor = user.detail[0].id
      this.userSearchIsInvalid = false
      this.updateCompanyBuyingServices(user.detail[0])
    },
    clearRequestedForUser() {
      this.exceptionSubmissionRequestData.requestedFor = ''
    },
    updateCompanyBuyingServices(userDetails) {
      //This method extracts out the 1st four digits from the costCenter that we receive from the API, matches it with the constants we maintain and auto-populates the field with required data.
      let userCostCenter = userDetails.costCenter.substring(0, 4);
      let companyBuyingService = this.countryListOptions && this.countryListOptions.length > 0 ? this.countryListOptions.find(companyObj => companyObj.costCenter === userCostCenter) : ''
      let companyBuyingListObj = []
      let companyBuyingListObjCheckbox = []
      if (companyBuyingService && Object.keys(companyBuyingService).length !== 0) {
        companyBuyingListObj.push(companyBuyingService)
      } else {
        let companyBuyingServiceCheckbox = this.oneIntakeCheckBoxCountries && this.oneIntakeCheckBoxCountries.length > 0 ? this.oneIntakeCheckBoxCountries.find(companyObj => companyObj.costCenter === userCostCenter) : ''
        if (companyBuyingServiceCheckbox && Object.keys(companyBuyingServiceCheckbox).length !== 0) {
          companyBuyingListObjCheckbox.push(companyBuyingServiceCheckbox)
        }
      }
      this.exceptionSubmissionRequestData.companyBuyingServices = companyBuyingListObj
      this.exceptionSubmissionRequestData.companyBuyingServiceCheckBox = companyBuyingListObjCheckbox
      this.exceptionSubmissionRequestData.isCompanyBuyingServicesOthersSelected = this.exceptionSubmissionRequestData.companyBuyingServices && this.exceptionSubmissionRequestData.companyBuyingServices.length > 0
    },
    validateAndSetCurrentTab() {
      this.$validator.validateAll().then((result) => {
        if (result && this.isCompanyBuyingServicesSelected()) {
          this.$emit('setCurrentTab', "SupplierInformationForExceptionRequest")
        } else
          window.scrollTo(0,0)
      })
    },
    isCompanyBuyingServicesSelected() {
      this.isCompanyBuyingServicesEmpty = this.exceptionSubmissionRequestData.companyBuyingServices.length === 0 && this.exceptionSubmissionRequestData.companyBuyingServiceCheckBox.length === 0
      return !this.isCompanyBuyingServicesEmpty
    },
    onAttachmentAdded(attachments) {
      this.exceptionSubmissionRequestData.attachments = attachments
    }
  },

}

</script>

<style scoped>
.preview-notification {
  margin-left: 0
}

.select-style >>> .ui.selection.dropdown .menu {
  max-height: 150px;
}

.custom-input {
  margin-right: -5px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.oneIntakeCheckBoxCountries {
  margin-right: 4px;
}
</style>

<style scoped src="@/assets/stylesheets/vueSearchSelectOverrides.css">

</style>